// services/supabaseClient.js
import { createClient } from "@supabase/supabase-js";

// ⚠️ Vérification utile en dev
if (!process.env.REACT_APP_SUPABASE_URL || !process.env.REACT_APP_SUPABASE_ANON_KEY) {
  console.warn("⚠️ Supabase env variables manquantes");
}

export const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: false, // pas besoin de session pour ton use case upload simple
    },
  }
);